module.exports = __webpack_public_path__ + "static/media/DMSans-Bold.a2c010b5.ttf";